import React, {useEffect} from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './component/sellermodule/Login';
import Otp from './component/sellermodule/Otp';
import ForgotPassword from './component/sellermodule/ForgotPassword';
import ResetPassword from './component/sellermodule/ResetPassword';
import ChangePassword from './component/sellermodule/ChangePassword';
import Header from './component/sellermodule/Header';
import SalesReport from './component/sellermodule/SalesReport';
import ProfilePage from './component/sellermodule/ProfilePage';
import SettingsPage from './component/sellermodule/SettingsPage';
import MyApplications from './component/sellermodule/MyApplications';
import SideMenu from './component/sellermodule/SideMenu';
import SignUp from './component/sellermodule/SignUp';
import AddApplication from './component/sellermodule/AddApplication';
import HeaderAddApp from './component/sellermodule/HeaderAddApp';
import AddNewApplication from './component/sellermodule/AddNewApplication';
import CreateLicense from './component/sellermodule/CreateLicense';
import CreateAddOn from './component/sellermodule/CreateAddOn';
import { refreshAccessToken } from "./utils/tockenUtils";
import Dashboard from './component/sellermodule/Dashboard';
import ProductDetails from './component/sellermodule/ProductDetails';
import ProductPricing from './component/sellermodule/ProductPricing';
import Notifications from './component/sellermodule/Notifications';
import EditApplication from './component/sellermodule/EditApplication';
import EditLicense from './component/sellermodule/EditLicense';
import EditAddOnDetails from './component/sellermodule/EditAddOnDetails';
import ParticipantDetails from './component/sellermodule/ParticipantDetails';


function App() {

  useEffect(() => {
    const interval = setInterval(() => {
      refreshAccessToken().catch((err) => {
        console.error("Auto token refresh failed:", err);
      });
    }, 10 * 60 * 1000); // 25 minutes

    return () => clearInterval(interval); // Clear interval on unmount
  }, []);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "accessToken" && event.newValue === null) {
        window.location.href = "/";
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    const handleInitialAuth = async () => {
      const refreshToken = localStorage.getItem("refreshToken");
      const accessToken = localStorage.getItem("accessToken");
      const currentPath = window.location.pathname;

      const publicPaths = [
        "/",
        "/products",
        "/AppDetails",
        "/AppPricing",
        "/SignUp",
        "/ForgotPassword",
      ];
      const publicPathPatterns = [/^\/ResetPassword\/.*/, /^\/AppDetails\/.*/]; // regex pattern

      const isPublic =
        publicPaths.includes(currentPath) ||
        publicPathPatterns.some((regex) => regex.test(currentPath));

      if (refreshToken) {
        try {
          await refreshAccessToken();
          console.log("Access token refreshed on app load");
        } catch (err) {
          console.error("Token refresh failed, redirecting to homepage");
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          window.location.href = "/";
        }
      } else {
        if (accessToken) {
          console.log(
            "No refresh token but access token present, let routing handle"
          );
        } else {
          if (!refreshToken && !accessToken && !isPublic) {
            console.log("No tokens, redirecting to home");
            window.location.replace("/");
          }
        }
      }
    };

    handleInitialAuth();
  }, []);

  const ProtectedRoute = ({ element }) => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      return <Navigate to="/" replace />;
    }

    return element;
  };

  return (
    <div className="">
      <BrowserRouter>
      <Routes>
        <Route path='/' element={<Login></Login>} />
        <Route path='/otp' element={<Otp></Otp>} />
        <Route path='/forgotPassword' element={<ForgotPassword></ForgotPassword>} />
        <Route path='/resetPassword' element={<ResetPassword></ResetPassword>} />
        <Route path='/changePassword' element={<ChangePassword/>} />
        <Route path='/header' element={<Header></Header>} />
        <Route path='/salesReport' element={<ProtectedRoute element={<SalesReport/>}/>} />
        <Route path='/profile' element={<ProtectedRoute element={<ProfilePage/>}/>}  />
        <Route path='/settings'  element={<ProtectedRoute element={<SettingsPage/>}/>}  />
        <Route path='/myapplication' element={<ProtectedRoute element={<MyApplications/>}/>} />
        <Route path='/sidemenu' element={<SideMenu/>} />
        <Route path='/signup' element={<SignUp/>} />
        <Route path='/addApplication' element={<AddApplication/>} />
        <Route path='/headerAddApp' element={<HeaderAddApp/>} />
        <Route path='/addNewApplication' element={<AddNewApplication/>} />
        <Route path='/createLicense' element={<CreateLicense/>} />
        <Route path='/createAddOn' element={<CreateAddOn/>} />
        <Route path='/dashboard' element={<ProtectedRoute element={<Dashboard/>}/>} />
        <Route path='/productdetails' element={<ProductDetails/>} />
        <Route path='/productpricing' element={<ProductPricing/>} />
        <Route path='/notifications' element={<Notifications/>} />
        <Route path='/editApplication' element={<EditApplication/>} />
        <Route path='/editlicense' element={<EditLicense/>} />
        <Route path='/editaddondetails' element={<EditAddOnDetails/>} />
        <Route path='/participantdetails' element={<ParticipantDetails/>} />
        
        </Routes></BrowserRouter>
      
    </div>
  );
}

export default App;
